module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row headerNavClass",
    attrs: {
      "borderStyle": _vm.borderStyle,
      "registeredDetail": _vm.registeredDetail
    }
  }, [_c('div', {
    staticClass: "headerNavImageClass",
    staticStyle: {
      "font-size": "20px",
      "color": "#fff"
    }
  }, [_c('div', {
    staticClass: "imageDiv",
    on: {
      "click": _vm.backIndexHtml
    }
  }, [_c('img', {
    staticClass: "backIndexImage",
    attrs: {
      "src": require("../../../static/img/account/developer-2.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "20px",
      "color": "#fff",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "divAllClass",
    staticStyle: {
      "display": "flex",
      "margin-left": "6px"
    }
  }, [_c('div', {
    ref: "myDevelopmentPlan",
    staticClass: "distribute developerAll developerAllShow developerPlan",
    on: {
      "click": function($event) {
        _vm.btnBackStyle($event, 'developmentPlan')
      }
    }
  }, [_vm._v(_vm._s(this.$t('developmentPlan')))]), _vm._v(" "), _c('span', {
    staticClass: "spanBorderClass"
  }, [_vm._v("|")]), _vm._v(" "), _c('div', {
    ref: "myfile",
    staticClass: "documentation developerAll developerAllShow",
    on: {
      "click": function($event) {
        _vm.btnBackStyle($event, 'file')
      }
    }
  }, [_vm._v(_vm._s(this.$t('file')))]), _vm._v(" "), _c('span', {
    staticClass: "spanBorderClass"
  }, [_vm._v("|")]), _vm._v(" "), _c('a', {
    ref: "mydiscuss",
    staticClass: "support developerAll developerAllShow",
    attrs: {
      "href": _vm.forumUrl
    },
    on: {
      "click": function($event) {
        _vm.btnBackStyle($event, 'discuss')
      }
    }
  }, [_vm._v(_vm._s(this.$t('discuss')))]), _vm._v(" "), _c('span', {
    staticClass: "spanBorderClass"
  }, [_vm._v("|")]), _vm._v(" "), _c('div', {
    staticClass: "blog developerAll developerAllHide",
    attrs: {
      "title": "暂未开放"
    },
    on: {
      "click": function($event) {
        _vm.btnBackStyle($event, 'blog')
      }
    }
  }, [_vm._v(_vm._s(this.$t('blog')))]), _vm._v(" "), _c('span', {
    staticClass: "spanBorderClass"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "flex",
      "flex-grow": "1"
    }
  }), _vm._v(" "), _c('div', {
    ref: "myLogin",
    staticClass: "account developerAll developerAllShow",
    on: {
      "mouseenter": function($event) {
        _vm.loginMouseenterFunc()
      },
      "mouseleave": function($event) {
        _vm.loginMouseleaveFunc()
      },
      "click": function($event) {
        _vm.btnBackStyle($event, 'login')
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowSelect),
      expression: "!isShowSelect"
    }]
  }, [_vm._v(_vm._s(_vm.loginOut))]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowSelect),
      expression: "isShowSelect"
    }],
    staticStyle: {
      "width": "19px",
      "height": "24px"
    },
    attrs: {
      "src": require("../../../static/img/header/account_null.png"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "rectangle_10"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27e3e676"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/HeaderIndex.vue
// module id = 1477
// module chunks = 1